import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { audienceMinerAccess } from "@/features/audience-miner/access/audience-miner-access";

export const AudienceMinerRoute: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { state } = useAuth();
    return audienceMinerAccess.can(state, "view") ? <>{children}</> : <Navigate to="/command-center" replace />;
};
